import { createApi as e } from "../../../node_modules/@reduxjs/toolkit/dist/query/react/rtk-query-react.modern.js";
import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK as o } from "../constants.js";
const r = ({ baseUrl: r2, baseQuery: t }) => {
  const n = e({ reducerPath: "meteringNodeLocationTypeApi", baseQuery: t({ baseUrl: `${r2}/metering-node-locations` }), keepUnusedDataFor: o, endpoints: (e2) => ({ getMeteringNodeLocationType: e2.query({ query: () => ({ url: "/" }) }) }) }), { useGetMeteringNodeLocationTypeQuery: i } = n;
  return { meteringNodeLocationTypeApi: n, useGetMeteringNodeLocationTypeQuery: i };
};
export {
  r as initializeMeteringNodeLocationTypeApi
};
//# sourceMappingURL=meteringNodeLocationTypeApi.js.map
